import './faq-list.scss';

export default () => {

};
